import type {EntityListViewType} from 'nutshell-core/types';

const DEFAULT_SORT_FIELD = 'name';
const DEFAULT_SORT_FIELD_LEADS_LIST = '-createdTime';
const DEFAULT_SORT_FIELD_BOARD = 'value';

/**
 * Called whenever the "view" (board, map, list, chart) changes. If the new view
 * is the board, we'll adjust our sort to ensure that its a valid sort for the
 * board.
 *
 * @param  {string} currentSort         - current sort field applied
 * @param  {string} newView           - string id of new view
 * @return {Object[]}                   - New array of filter objects, adjusted for singular pipeline
 */
export function sanitizeSortForView(
    currentSort: string,
    newView: EntityListViewType,
    topLevelEntity: string
): string {
    if (newView === 'list' && topLevelEntity === 'leads') {
        return currentSort || DEFAULT_SORT_FIELD_LEADS_LIST;
    }

    if (newView !== 'board') {
        return currentSort || DEFAULT_SORT_FIELD;
    }

    return isValidBoardSort(currentSort) ? currentSort : DEFAULT_SORT_FIELD_BOARD;
}

function isValidBoardSort(sortField: string): boolean {
    const validBoardSortFields = ['value', 'createdTime', 'closedTime', 'nextActivityStartTime'];

    // Adding `slice(1) here so that descending sorts like `-value` also get validated
    return (
        validBoardSortFields.includes(sortField) ||
        validBoardSortFields.includes(sortField.slice(1))
    );
}
